module.exports = __webpack_public_path__ + "e328a30135a1a275a72c6c0af13b0bbb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/numbers/3.png
// module id = 2950
// module chunks = 0